"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("core/types");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const eng_png_1 = tslib_1.__importDefault(require("../../../assets/media/images/eng.png"));
const geo_png_1 = tslib_1.__importDefault(require("../../../assets/media/images/geo.png"));
const Language = () => {
    const { changeLanguage, selectedLanguage } = (0, TranslationProvider_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", { className: 'pointer topbar-item', children: (0, jsx_runtime_1.jsxs)("span", { onClick: () => changeLanguage(selectedLanguage === types_1.LanguageType.GEO ? types_1.LanguageType.ENG : types_1.LanguageType.GEO), children: [" ", (0, jsx_runtime_1.jsx)("img", { className: 'flag-icon ml-2', alt: 'geo', src: selectedLanguage === types_1.LanguageType.GEO ? geo_png_1.default : eng_png_1.default })] }) }));
};
exports.default = Language;
